import { Button, Stack, styled, Typography } from '@mui/material';

export const StyledTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[900],
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '16px',
}));

export const StyledSubTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
  fontWeight: 500,
  fontSize: 11,
  lineHeight: '16px',
}));

export const StyledReleaseOptionContainer = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  backgroundColor: 'unset',
  border: 'none',
  cursor: 'pointer',
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  width: theme.spacing(37.5),
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
  },
}));

export const StyledTextContainer = styled(Stack)(() => ({
  alignItems: 'flex-start',
  flexDirection: 'column',
}));

export const StyledIconContainer = styled(Stack)(({ theme }) => ({
  // @ts-ignore
  backgroundColor: theme.palette.secondary.darker,
  padding: theme.spacing(1),
  borderRadius: theme.spacing(0.5),
  color: theme.palette.grey[100],
  marginRight: theme.spacing(1),
}));
